import { combineReducers } from "redux";
import isLoading from "./reducers/isLoading";
import authentication from "./reducers/authentication";

export default combineReducers({
  isLoading,
  authentication,
});
